import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { EMPTY, catchError, map } from 'rxjs';
import { EnvironmentApiService } from '@uc/utilities';
import {
	Ranking,
	RankingTypes,
	RankingsSlugs,
	RankingsSubject,
} from '../models/rankings.models';

@Injectable({
	providedIn: 'root',
})
export class RankingsApiService {
	constructor(
		private _http: HttpClient,
		private _apiSrv: EnvironmentApiService,
		private _router: Router,
	) {}

	getSubjectRankingsData() {
		return this._http.get<RankingsSubject[]>(
			this._apiSrv.JSON_URL + 'rankings/subject-rankings.json',
		);
	}

	getUniversityRankings(slug: RankingsSlugs, rankingType: RankingTypes) {
		if (rankingType === 'category') {
			return this._getCategoryRankings('rankings/' + slug);
		} else if (rankingType === 'region') {
			return this._getRegionRankings(slug);
		}
		return this._getAllRankings();
	}

	private _getCategoryRankings(url: string) {
		return this._http.get<Ranking[]>(this._apiSrv.API_URL + url).pipe(
			catchError((error) => this._catchError(error)),
			map((response) => response),
		);
	}

	private _getRegionRankings(region: string) {
		const params = {
			country: region.replace(/-/g, '_'),
		};
		return this._http
			.get<Ranking[]>(this._apiSrv.API_URL + `rankings/`, { params })
			.pipe(
				catchError((error) => this._catchError(error)),
				map((response) => response),
			);
	}

	private _getAllRankings() {
		return this._http.get<Ranking[]>(this._apiSrv.API_URL + 'rankings/').pipe(
			catchError((error) => this._catchError(error)),
			map((response) => response),
		);
	}

	private _catchError(error: any) {
		if (error.status === 404) {
			this._router.navigate(['/404']);
		}
		return EMPTY;
	}
}
